<template>
<div class="courier-info">
    <h1 class="courier-title">Kuryerlik xizmati nima?</h1>
    
    <p class="courier-text">
      Kuryerlik xizmati - jo'natuvchining manzilidan pochta jo'natmalarini qabul qilib, oluvchining manziligacha yetkazib berish xizmati. Kuryerlik pochta jo'natmalari to'g'ridan-to'g'ri kuryer orqali yetkazib berish yo'li bilan amalga oshirilishi sababi, kuryerlik jo'natmalarini oluvchilarga sifatli va qisqa muddatlarda yetkazib berish ta'minlanadi. Kuryerlik pochta jo'natmalari manzilga yetkazib berilgach ushbu xaqidagi ma'lumot jo'natuvchiga taqdim etib boriladi.
    </p>
    
    <p class="courier-text">
      Kuryerlik pochtasi – jo'natma varaqalar, xatlar, bannerlar, posilkalar, bosma nashrlar, plastik kartochkalardan iborat bo'lib, ular qisqa muddatda yetkazib beriladi (topshiriladi).
      Jo'natuvchi har bir kuryerlik jo'natmasi to'g'risidagi ma'lumotni unga taqdim qilingan shtrix-kod orqali "Pochta logistikasi" tizimi orqali onlayn kuzatib borish va kuryerlik jo'natmasini oluvchilarga yetkazib berilganlik bo'yicha ma'lumotlarni olish imkoniyati mavjud.
    </p>
  </div>
<!-- description body Section End -->
</template>




<style scoped>
@font-face {
    font-family: "Roboto-Condensed";
    src: url(/public/assets/css/fonts/Roboto-Condensed.ttf);
}
@font-face {
    font-family: "Roboto-BoldCondensed";
    src: url(/public/assets/css/fonts/Roboto-BoldCondensed.ttf);
}

.courier-info {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.courier-title {
  color: #1e3c87;
  font-size: 72px;
  font-weight: bold;
  margin-bottom: 20px;
  font-style: italic;
}

.courier-text {
  color: #333;
  line-height: 1.6;
  margin-bottom: 16px;
  font-size: 24px;
  text-align: justify;
}

@media (max-width: 600px) {
  .courier-info {
    padding: 15px;
  }
  
  .courier-title {
    font-size: 24px;
  }
  
  .courier-text {
    font-size: 14px;
  }
}



</style>